export default "__VITE_ASSET__BWLwiVkb__"